import React from "react";
import { Link } from "react-router-dom";
import { Package, GraduationCap, BadgeCheck, Store, Info } from "lucide-react";
import { CATEGORIAS_DIGITALES, COURSE_CATEGORIES, MKT_GOLD, MKT_TINT } from "../../lib/marketplace";
import { SELLER_NOTICE, COURSE_NOTICE } from "./mktui";
import { FavoriteButton } from "../../components/FavoriteButton";

export const CATALOG_CATS = [
  { id: "plantillas", label: "Plantillas profesionales" },
  { id: "software", label: "Software y aplicaciones" },
  { id: "plugins", label: "Plugins y extensiones" },
  { id: "bim", label: "Recursos BIM" },
  { id: "cad", label: "Recursos CAD" },
  { id: "dashboards", label: "Dashboards e indicadores" },
  { id: "cursos", label: "Cursos independientes" },
  { id: "libros", label: "Libros digitales" },
  { id: "multimedia", label: "Recursos multimedia" },
];

export const catLabel = (id) =>
  CATEGORIAS_DIGITALES.find((c) => c.id === id)?.label ||
  COURSE_CATEGORIES.find((c) => c.id === id)?.label ||
  id;

export const precioTxt = (item) => {
  if (item.tipo === "curso" && item.gratuito) return "Gratis";
  const base = Number(item.precio || 0);
  const promo = Number(item.precioPromo || 0);
  const vigente = promo > 0 && promo < base ? promo : base;  // precio real que se cobra
  if (vigente === 0) return item.tipo === "curso" ? "Gratis" : "S/ 0.00";
  return `S/ ${vigente.toFixed(2)}`;
};

export function CatalogCard({ item }) {
  const esCurso = item.tipo === "curso";
  const to = esCurso ? `/tienda/curso/${item.id}` : `/tienda/producto/${item.id}`;
  const tienda = item.tienda || {};
  const promo = item.precioPromo && Number(item.precioPromo) > 0 && Number(item.precioPromo) < Number(item.precio);
  return (
    <Link to={to} data-testid={`cat-card-${item.id}`} className="group rounded-2xl border border-slate-200 bg-white shadow-soft overflow-hidden flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all">
      <div className="h-36 relative flex items-center justify-center overflow-hidden" style={{ background: item.cover ? undefined : `linear-gradient(135deg, #FFFFFF, ${MKT_TINT})` }}>
        {item.cover ? <img src={item.cover} alt={item.titulo} className="w-full h-full object-cover group-hover:scale-105 transition-transform" /> : (esCurso ? <GraduationCap size={34} style={{ color: MKT_GOLD }} /> : <Package size={34} style={{ color: MKT_GOLD }} />)}
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-bold text-white" style={{ backgroundColor: esCurso ? "#7E22CE" : MKT_GOLD }}>
          {esCurso ? <GraduationCap size={11} /> : <Package size={11} />} {esCurso ? "Curso independiente" : "Producto digital"}
        </span>
        <FavoriteButton stop item={{ tipo: item.tipo, ref_id: item.id, titulo: item.titulo, subtitulo: tienda.vendedor || tienda.nombre || "", enlace: to, imagen: item.cover || "" }} className="absolute top-2 right-2 w-8 h-8 bg-white/90 backdrop-blur shadow-sm hover:bg-white" />
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <p className="text-[10px] font-bold uppercase tracking-wide" style={{ color: MKT_GOLD }}>{catLabel(item.categoria)}</p>
        <h3 className="mt-1 font-bold text-slate-900 text-sm leading-tight line-clamp-2">{item.titulo}</h3>
        <p className="mt-1 text-xs text-slate-500 inline-flex items-center gap-1">
          <Store size={12} /> {tienda.vendedor || tienda.nombre || (esCurso ? item.instructor : "Vendedor")}
          {tienda.verificado && <BadgeCheck size={13} className="text-emerald-600" />}
        </p>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-extrabold text-slate-900">{precioTxt(item)}</span>
          {promo && <span className="text-xs text-slate-400 line-through">S/ {Number(item.precio).toFixed(2)}</span>}
        </div>
        <p className="mt-2 text-[10px] text-slate-400 flex items-start gap-1"><Info size={10} className="mt-0.5 flex-shrink-0" /> {esCurso ? COURSE_NOTICE : SELLER_NOTICE}</p>
        <span className="mt-3 inline-flex items-center justify-center gap-1 px-3 py-2 rounded-xl text-sm font-bold text-white transition-all" style={{ backgroundColor: MKT_GOLD }}>Ver detalle</span>
      </div>
    </Link>
  );
}

export function TiendaCard({ tienda }) {
  return (
    <Link to={`/tienda/t/${tienda.id}`} data-testid={`cat-tienda-${tienda.id}`} className="rounded-2xl border border-slate-200 bg-white shadow-soft p-4 flex items-center gap-3 hover:shadow-md transition-all">
      <span className="w-12 h-12 rounded-xl overflow-hidden bg-slate-100 flex items-center justify-center flex-shrink-0">
        {tienda.logo ? <img src={tienda.logo} alt="" className="w-full h-full object-cover" /> : <Store size={22} style={{ color: MKT_GOLD }} />}
      </span>
      <div className="min-w-0">
        <p className="font-bold text-slate-900 text-sm truncate inline-flex items-center gap-1">{tienda.nombre} {tienda.verificado && <BadgeCheck size={13} className="text-emerald-600" />}</p>
        <p className="text-xs text-slate-500 truncate">{tienda.vendedor}</p>
      </div>
    </Link>
  );
}
